<template>
  <div
    class="flex flex-col gap-1 pb-2 my-3 sm:max-w-2xl sm:mx-auto border border-theme-secondary border-dashed mx-2"
  >
    <div class="bg-theme-secondary/30 p-0.5 uppercase text-sm text-center">
      {{ $t('navigation.premium') }}
    </div>
    <h2 class="text-center">{{ $t('premium.tags_title') }}</h2>
    <div class="flex gap-2 p-2 w-full items-center">
      <div class="grow">
        <div v-if="tags" class="flex flex-wrap gap-1">
          <BadgeTag v-for="tag in tags" :tag="tag" @remove-tag="(theTag)=>removeTag(theTag)" />
          <div v-if="tags.length == 0">{{ $t('premium.no_tags') }}</div>
        </div>
        <ErrorView v-if="error" :error="error" size="small" @retry="refresh" :status="status" :vertical="true" />
      </div>
      <div class="flex flex-col gap-1 flex-shrink-0">
        <h3>{{ $t('premium.add_tag') }}</h3>
        <div class="relative">
          <input type="text"
                 v-model="input"
                 @input="tagsForInput($event.target.value)"
                 @focusin="tagsForInput($event.target.value)"
                 @focusout="abortTagInput"
                 class="h-full uppercase w-full border border-theme-secondary bg-transparent p-[10px] outline outline-0 focus:border-theme-primary"
          />
          <div
            v-if="autocompleteLoading"
            class="h-full absolute right-2 top-0 loading loading-spinner"
          ></div>
        </div>
        <div class="relative">
          <ul
            class="bg-white absolute top-0 right-0 left-0 mt-0.5 rounded-md shadow-md z-30"
          >
            <li
              class="p-1 hover:bg-theme-primary cursor-pointer rounded-md flex"
              v-for="(tag, index) in tagRecommendations"
              @click="addTag(tag)"
            >
              <p class="grow text-black uppercase">{{ tag }}</p><img src="~/assets/icon/arrow-right-black-small.svg"
                                                                     :alt="$t('accessibility.arrow_right')" />
            </li>
          </ul>
        </div>

      </div>
    </div>
  </div>
</template>
<script setup lang="ts">

import { FetchError } from 'ofetch';
const props = defineProps<{ spot: SpotDetail }>();
const tagRecommendations = ref<Array<String>>([]);
const autocompleteLoading = ref(false);
const autocompleteError = ref<FetchError | undefined>();
const input = ref<string>('');

const { data: tags, error, refresh, status} = await useApiAuth().asyncData<Array<String>>('spots/' + props.spot.id + '/tags/');

async function tagsForInput(newInput: string) {
  input.value = newInput;
  autocompleteLoading.value = true;
  autocompleteError.value = undefined;

  useApiAuth().get<Array<string>>('spots/' + props.spot.id + '/tags/recommendations/' + newInput).then((result) => {
    if (result && result.length > 0) {
      if (input.value != '' && !tags.value.includes(input.value)) {
        tagRecommendations.value = [input.value, ...result];
      } else {
        tagRecommendations.value = result;
      }
    } else {
      if (input.value != '' && !tags.value.includes(input.value)) {
        tagRecommendations.value = [input.value];
      } else {
        tagRecommendations.value = [];
      }
    }
  }).catch((error) => {
    autocompleteError.value = error;
  }).finally(() => {
    autocompleteLoading.value = false;
  });
}

const addTag = (tag: string) => {
  autocompleteLoading.value = true;
  const formData = new FormData();
  formData.append('tag', tag);
  useApiAuth().put<String>('spots/' + props.spot.id + '/tags/', formData).then((result) => {
    tags.value.push(result);
    tagRecommendations.value = [];
    input.value = '';
  }).catch((error) => {
    errorMessage.value = 'generic';
  }).finally(() => {
    autocompleteLoading.value = false;
  });

};

function removeTag(tag: string) {
  useApiAuth().del('spots/' + props.spot.id + '/tags/' + tag).then(() => {
    tags.value = tags.value.filter((t) => t != tag);
  }).catch(() => {
    errorMessage.value = 'generic';
  });
}

function abortTagInput() {
  setTimeout(() => {
    tagRecommendations.value = [];
    autocompleteLoading.value = false;
  }, 200);
};

</script>
